(function () {
  'use strict';

  angular
    .module('app.insightReportOpportunity')
    .controller('insightReportOpportunityCtrl', insightReportOpportunityCtrl);

  insightReportOpportunityCtrl.$inject = ['measureService', 'insightReportOpportunityService', '$scope', '$rootScope'];
  function insightReportOpportunityCtrl(measureService, insightReportOpportunityService, $scope, $rootScope) {

    $scope.$on('refreshDashboard', function(event, args) {
      getDataInsightReportOpportunity();
    });


    $scope.verticalPrint = "";

    $scope.verticalListChannel = [];
    
    var enableWatchChannel = false;
    var channelOpportunityData = null;
    var channelOpportunityNotNA = false;

    $scope.selectVertical = function(data) {
      $scope.verticalPrint = data.name;
    }

    $scope.$watch('selectedVerticalChannel', function(newValue, oldValue){
      if(enableWatchChannel && newValue !== oldValue && newValue !== undefined && newValue.length != 0){        
        var indexNo = 0;
        for(var i = 0; i < $scope.verticalListChannel.length; i++){
          if(newValue[0].name.localeCompare($scope.verticalListChannel[i].name) == 0){
            indexNo = i;
          }
        }

        if(channelOpportunityData != null && channelOpportunityData !== undefined){
          if(channelOpportunityNotNA != true){
            generateChannelOpportunity(channelOpportunityData, indexNo);
          } else{
            indexNo += 1;
            generateChannelOpportunity(channelOpportunityData, indexNo);
          }
        }
      }
    });

    function generateChannelOpportunity (channelOpportunity, indexNo) {
      $scope.channelOpportunity = channelOpportunity[indexNo];
    }

    function getDataInsightReportOpportunity() {
      var params = $rootScope.saveParams;
      if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
        return;
      }
      params.date = 30;
      
      getChannelOpportunityData(params);
    }

    function getChannelOpportunityData(params){
      insightReportOpportunityService.getChannelOpportunityData(params)
        .then(function(response){
            channelOpportunityData = response.channelOpportunity;
			//Check if Vertical List contain "NA"
          if(response.channelOpportunity.length > 0) {
            if(response.channelOpportunity[0][2].verticalName != "NA"){
              generateChannelOpportunity(response.channelOpportunity, 0);
              channelOpportunityNotNA = false;
            } else{
              generateChannelOpportunity(response.channelOpportunity, 1);
              channelOpportunityNotNA = true;
            }
            $scope.verticalListChannel = [];
            angular.forEach(response.channelOpportunity, function(item){
              var tempItem = {name: item[2].verticalName.toUpperCase()};
              item.splice(2,1);
              if(tempItem.name != "NA"){
                $scope.verticalListChannel.push(tempItem);
              }
              
              if($scope.verticalListChannel.length > 1){
                enableWatchChannel = true;
              }
            })

            $scope.verticalPrint = $scope.verticalListChannel[0].name;
          }
        })
        .catch(function(message){
          channelOpportunityData = [];
          $scope.channelOpportunity = [];
          $scope.verticalListChannel = [];

        })
        .finally(function(){
          $rootScope.$broadcast('sectionLoaded');
        })            
    }

    // first initiating
    getDataInsightReportOpportunity();
  }
})();